import PageHero from "../components/sections/PageHero";
import FAQ from "../components/sections/FAQ";
import CTASection from "../components/sections/CTASection";
import { Link } from "react-router-dom";

export default function FAQPage() {
  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title="Common questions,"
        italic="answered honestly."
        subtitle="Everything you need to know about our epoxy flooring, waterproofing and painting services — from timelines and warranties to material choices and site preparation."
      />

      {/* Intro content block — expands text-to-code ratio */}
      <section
        data-testid="faq-intro"
        className="py-16 md:py-24 bg-white"
      >
        <div className="max-w-4xl mx-auto px-5 md:px-8 space-y-6 text-ink-mid leading-relaxed text-base md:text-lg">
          <p>
            Urban Painter has been serving customers across Gurugram and Delhi NCR
            since 2019, with epoxy flooring now available Pan India — from
            Bangalore and Hyderabad down to Chennai and out to Ahmedabad, Pune,
            Kolkata and Baddi. Below are the questions we&rsquo;re asked most
            often, grouped so you can quickly find what applies to your
            project.
          </p>
          <p>
            If your specific situation isn&rsquo;t covered here, WhatsApp us
            with a photograph of the site — we usually respond within the same
            working day with the next step: whether it&rsquo;s a straight
            quotation, a site inspection or a preliminary recommendation on the
            right system.
          </p>
          <ul className="pt-4 grid grid-cols-1 md:grid-cols-3 gap-3 text-sm font-mono tracking-wide text-ink-muted">
            <li className="border border-ink-line p-4">
              <div className="text-[10px] tracking-[0.25em] uppercase text-ink-muted mb-2">
                Services
              </div>
              <Link to="/epoxy-flooring" className="block text-ink hover:text-orange">Epoxy Flooring — Pan India</Link>
              <Link to="/waterproofing" className="block text-ink hover:text-ink-soft">Waterproofing — NCR</Link>
              <Link to="/painting" className="block text-ink hover:text-ink-soft">Painting — NCR</Link>
            </li>
            <li className="border border-ink-line p-4">
              <div className="text-[10px] tracking-[0.25em] uppercase text-ink-muted mb-2">
                Cities we serve
              </div>
              <span className="text-ink text-xs">Gurgaon · Manesar · Sohna · Delhi NCR · Bangalore · Hyderabad · Kolkata · Pune · Chennai · Baddi · Ahmedabad</span>
            </li>
            <li className="border border-ink-line p-4">
              <div className="text-[10px] tracking-[0.25em] uppercase text-ink-muted mb-2">
                Property types
              </div>
              <span className="text-ink text-xs">Independent houses · Apartments · Offices · Showrooms · Warehouses · Factories · Industrial units</span>
            </li>
          </ul>
        </div>
      </section>

      <FAQ heading="Everything worth asking." />

      {/* Closing content block — more meaningful copy */}
      <section
        data-testid="faq-closing"
        className="py-16 md:py-24 bg-ink-mist border-t border-ink-line"
      >
        <div className="max-w-4xl mx-auto px-5 md:px-8">
          <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
            One last thing
          </div>
          <h2 className="font-display text-2xl md:text-4xl text-ink leading-tight tracking-[-0.02em] mb-6">
            The single question that saves the most{" "}
            <span className="font-serif-italic font-normal">rework</span> is
            the one asked before the job starts.
          </h2>
          <div className="space-y-5 text-ink-mid leading-relaxed">
            <p>
              A lot of paint failure, floor delamination and re-appearing damp
              patches trace back to a decision made before any material was
              opened. Was the substrate really tested? Was the primer specified
              for the moisture level actually there? Is the exterior emulsion
              rated for the humidity you get in the monsoon? Is the epoxy
              system rated for the forklift traffic that warehouse actually
              carries?
            </p>
            <p>
              We&rsquo;d rather have a slightly longer conversation on day one
              than repaint or re-lay a floor on day 400. If you&rsquo;re
              planning a project — even one that&rsquo;s months away — send us
              a note. It costs nothing to know what to specify.
            </p>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/contact"
              data-testid="faq-contact-cta"
              className="inline-flex items-center gap-2 bg-ink hover:bg-ink-soft text-white px-6 py-3 text-[11px] tracking-[0.25em] uppercase"
            >
              Ask a question
            </Link>
            <Link
              to="/projects"
              className="inline-flex items-center gap-2 border border-ink hover:bg-ink hover:text-white text-ink px-6 py-3 text-[11px] tracking-[0.25em] uppercase transition-colors"
            >
              View projects
            </Link>
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
